import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
// import H from "../Images/h.jpg";
import WBA from "../Images/Company/WBA.png";
// import LI from "../Images/LI.png"
const ClientTestimonial = () => {
  // Detect when the section is in view
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.2 });

  return (
    <div ref={ref} className="bg-gradient-to-b from-purple-100 to-white py-16 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Button Animation */}
        <motion.button 
          className="bg-[#432DD7] text-white py-3 px-6 rounded-full text-lg font-[Nunito] font-semibold"
          initial={{ opacity: 0, y: -20 }} 
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
          whileHover={{ scale: 1.05 }}
        >
          Client Testimonial
        </motion.button>

        {/* Intro Text Animation */}
        <motion.p 
          className="text-gray-700 font-[400] text-[#62739E] mt-4 text-[16px]"
          initial={{ opacity: 0, y: 20 }} 
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          We offer a comprehensive range of IT services to help your business grow and succeed...
        </motion.p>
      </div>

      {/* Testimonial Box */}
      <motion.div 
        className="max-w-5xl mx-auto mt-10 bg-gray-900 text-white p-8 rounded-xl flex flex-col-reverse md:flex-row gap-5 items-center"
        initial={{ opacity: 0, x: -30 }} 
        animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
        transition={{ duration: 0.7 }}
      >
        {/* Left Section (Text & Client Info) */}
        <motion.div 
          className="flex-1"
          initial={{ opacity: 0, x: -20 }} 
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="flex items-center gap-4 mb-4">
            {/* Client Image */}
            <motion.img 
              src={WBA} 
              alt="Client" 
              className="w-12 h-12 rounded-full object-cover"
              whileHover={{ scale: 1.1 }}
            />
            
            {/* Client Details */}
            <div>
              <h3 className="text-lg font-bold font-[Nunito]">Bhavna Dabhi</h3>
              <p className="text-gray-400 font-[Nunito] text-sm">Founder, WBA & Bhavna Numerology</p>
            </div>

            {/* LinkedIn Logo */}
            {/* <motion.img 
              src={LI} 
              alt="LinkedIn" 
              className="w-5 h-5 cursor-pointer"
              whileHover={{ scale: 1.2 }}
            /> */}
          </div>

          {/* Testimonial Quotes */}
          <motion.p 
            className="text-gray-300 border-l-4 text-justify font-[Nunito] border-purple-600 pl-4"
            initial={{ opacity: 0, x: -10 }} 
            animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -10 }}
            transition={{ duration: 1, delay: 0.7 }}
          >
          I had the pleasure of working with Godhani Technology, and I must say, their dedication to excellence is truly commendable. From the very beginning, their team showcased professionalism, deep technical expertise, and an unwavering commitment to delivering quality results. Whether it was website development or digital marketing, every aspect was handled with precision and creativity. I’m incredibly impressed by their innovative approach and prompt support. I highly recommend Godhani Technology to anyone looking for reliable and top-notch IT solutions.
          </motion.p> <br />
          <motion.p 
            className="text-gray-300 border-l-4 text-justify font-[Nunito] border-purple-600 pl-4"
            initial={{ opacity: 0, x: -10 }} 
            animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -10 }}
            transition={{ duration: 0.9, delay: 0.5 }}
          >
            "Working with Godhani Technology gave me complete confidence in their abilities, and I can proudly say they are one of the best IT partners I’ve come across. I highly recommend them to anyone who is looking for reliable, future-focused, and client-centric tech services."
          </motion.p>
          <br />
         
            </motion.div>

        {/* Right Section (Image Box) */}
        {/* <motion.div 
          className="md:w-1/3 w-full h-100 bg-white rounded-lg md:ml-6"
          initial={{ opacity: 0, x: 30 }} 
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
          transition={{ duration: 0.7, delay: 0.4 }}
        >
          <img src="" alt="Client Testimonial" />
        </motion.div> */}
      </motion.div>
    </div>
  );
};

export default ClientTestimonial;
